import { render, staticRenderFns } from "./SalesRecapTransactions.vue?vue&type=template&id=6ec4ab2e&"
import script from "./SalesRecapTransactions.vue?vue&type=script&lang=js&"
export * from "./SalesRecapTransactions.vue?vue&type=script&lang=js&"
import style0 from "./SalesRecapTransactions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports